// Frontend mirror of core/rbac.py's ROLE_PERMISSIONS — used only to decide
// what to SHOW in the sidebar. The backend is the real enforcer (every
// endpoint still checks this independently); this just keeps a role from
// seeing tabs it would immediately get blocked from using.

export const CLUSTER_VIEW_CUSTOMER = 'cluster:view_customer';
export const CLUSTER_CREATE_CUSTOMER = 'cluster:create_customer';
export const EDGE_CREDS_MANAGE = 'edge_creds:manage';
export const CLUSTER_VIEW_DEV = 'cluster:view_dev';
export const CLUSTER_MARK_DELETION = 'cluster:mark_deletion';

const ROLE_PERMISSIONS = {
  admin: new Set([CLUSTER_VIEW_CUSTOMER, CLUSTER_CREATE_CUSTOMER, EDGE_CREDS_MANAGE, CLUSTER_VIEW_DEV, CLUSTER_MARK_DELETION]),
  platform: new Set([CLUSTER_VIEW_CUSTOMER, CLUSTER_VIEW_DEV]),
  cse: new Set([CLUSTER_VIEW_CUSTOMER, CLUSTER_CREATE_CUSTOMER, EDGE_CREDS_MANAGE]),
  se_sa: new Set([CLUSTER_VIEW_CUSTOMER, CLUSTER_CREATE_CUSTOMER, EDGE_CREDS_MANAGE, CLUSTER_MARK_DELETION]),
  dev: new Set([CLUSTER_VIEW_DEV]),
  user: new Set([]),
};

export function roleHas(role, permission) {
  return ROLE_PERMISSIONS[role]?.has(permission) ?? false;
}
